'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _l10n = require('../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var classList = this.compileStyle(_index2.default),
        list = void 0;

    list = this._preparedList.map(function (item) {
        return _react2.default.createElement(
            'button',
            {
                onClick: _this._handleClick.bind(_this),
                type: 'button',
                className: classList.item,
                title: _react2.default.isValidElement(item.name) ? _l10n2.default.translate(item.stringName) : _l10n2.default.translate(item.name),
                key: 'item-' + item.id
            },
            _react2.default.isValidElement(item.name) ? item.name : _react2.default.createElement(
                'span',
                null,
                _l10n2.default.translate(item.name)
            )
        );
    });

    return _react2.default.createElement(
        'div',
        { ref: this._rootRef.bind(this), className: classList.root + ' ' + (this.props.className || '') },
        _react2.default.createElement(
            'div',
            { className: classList.input },
            _react2.default.createElement(
                'div',
                { className: classList.list, style: { top: this._getListPosition(classList.height) } },
                list
            )
        )
    );
}